import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const POST_PERIOD_REQUEST = "POST_PERIOD_REQUEST";
export const POST_PERIOD_SUCCESS = "POST_PERIOD_SUCCESS";
export const POST_PERIOD_ERROR = "POST_PERIOD_ERROR";

//* ACTIONS ------------------------------------------------
export const postPeriodRequest = (payload = {}, callback) => ({
  type: POST_PERIOD_REQUEST,
  payload,
  callback,
});

export const postPeriodSuccess = () => ({
  type: POST_PERIOD_SUCCESS,
});

export const postPeriodError = (error) => ({
  type: POST_PERIOD_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postPeriodServiceRequest = async ({ payrollId, ...data }) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data,
  });

  return request(`/payrolls/${payrollId}/periods`, options);
};
